export const getLanguageCodeForTranslation = (culture: string): string => {
  const languageMap: { [key: string]: string } = {
    "en-US": "en-US",
    "zh-CN": "zh-CN",
    "th-TH": "th",
    "vi-VN": "vi-VN",
    "hi-IN": "HI",
    "es-ES": "es-ES",
    "en-PH": "tl-PH",
    "zh-TW": "TW",
    "ko-KR": "KR",
    "ja-JP": "ja-JP",
    "id-IN": "id-IN",
    "ur-PK": "ur-PK",
  };
  return languageMap[culture] || "en-US";
};

export const getLanguageCodeForAuthPages = (culture: string): string => {
  const languageMap: { [key: string]: string } = {
    "en-US": "en",
    "zh-CN": "zh",
    zh: "zh",
    "th-TH": "th",
    th: "th",
    "vi-VN": "vi",
    vi: "vi",
    "hi-IN": "HI",
    HI: "HI",
    "es-ES": "es",
    es: "es",
    "en-PH": "tl",
    "tl-PH": "tl",
    tl: "tl",
    ph: "tl",
    "zh-TW": "TW",
    TW: "TW",
    "ja-JP": "jp",
    jp: "jp",
    ja: "jp",
    KR: "KR",
    "id-IN": "id",
    id: "id",
    "ur-PK": "ur",
    ur: "ur",
  };
  return languageMap[culture] || "en";
};
